import request from './request';

export const importWordDocument = (file) => {
  const formData = new FormData();
  formData.append('file', file);

  return request.post('/upload/word', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 60000
  });
};

export const deleteWordDocument = (sourceDocument) =>
  request.delete('/upload/word', {
    data: {
      source_document: sourceDocument
    }
  });

export const uploadSingleFile = (file, type = 'image') => {
  const formData = new FormData();
  formData.append('file', file);

  return request.post(`/upload/single?type=${encodeURIComponent(type)}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 60000
  });
};
